// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__main__1cJmG{display:flex;flex-wrap:wrap}.styles-module__list_container__1AtMY{border:1px solid;border-color:#ddd;border-radius:0.25rem;padding:0.375rem 0.75rem;overflow-y:scroll;min-height:100px;max-height:100px;margin-top:28px}.styles-module__add__1jifo{border-color:#ddd !important}\n", ""]);
// Exports
exports.locals = {
	"main": "styles-module__main__1cJmG",
	"list_container": "styles-module__list_container__1AtMY",
	"add": "styles-module__add__1jifo"
};
module.exports = exports;
